import "./Comp1.css";

import Video from "../Images/headerImg.mp4"


export default function Comp1() {
  return (
    <div className="comp1">
      <video className="responsive-video" src={Video} alt="error" autoPlay loop muted></video>
    </div>
  );
}
